import Axios from 'axios';

export default Axios.create({
  baseURL: `${process.env.REACT_APP_TUTOPIYA_BASE_URL_V2}`,
  headers: {
    'Content-type': 'application/json',
  },
});

export const authHttp = Axios.create({
  baseURL: `${process.env.REACT_APP_TUTOPIYA_BASE_URL_V2}`,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded',
  },
});
